import React, {useCallback, useEffect} from "react";
import {Select} from "antd";
import {useCookies} from "react-cookie";
import {useTranslation} from "react-i18next";
import {COOKIE} from "@tools/constants";
import defaultSettings from "@resources/defaultSettings";

const cookieName = COOKIE.CURRENCY
const currency = defaultSettings.currency

const CurrencySwitch: React.FC = () => {
    const [cookies, setCookie] = useCookies([cookieName])
    const {t} = useTranslation();

    const onCurrencyChange = useCallback((currency: string) => {
        setCookie(cookieName, currency, {path: "/", maxAge: 60 * 60 * 24 * 365 });
        window.location.reload();
    }, [setCookie]);

    useEffect(() => {
        if (!cookies[cookieName])
            onCurrencyChange(defaultSettings.defaultCurrency)
        else if(!defaultSettings.currency.includes(cookies[cookieName]))
            onCurrencyChange(defaultSettings.defaultCurrency)
    }, [cookies[cookieName], onCurrencyChange])

    if (currency.length < 2)
        return null

    return  <Select className="currencySwitch" value ={cookies[cookieName]} onChange={onCurrencyChange} popupMatchSelectWidth={false}>
            {currency.map(key => <Select.Option key={key} value={key}>{t(`lookup:currency.${key}`)}</Select.Option>)}
        </Select>
};

export default  CurrencySwitch;

